<div class="bg-white position-relative">
  <div class="border-bottom">
    <div class="p-4">
      <h3 class="pt-2">{{ 'Sellers.Products.ChangePassword' | translate }}</h3>
      <p>{{ 'Sellers.Products.ChangePasswordDesc' | translate }}</p>
    </div>
  </div>

  <form #f="ngForm" class="p-4" [formGroup]="changePasswordForm" *ngIf="changePasswordForm">
    <div class="row justify-content-end">
      <div class="col-md-4 mb-3">
        <label>{{ 'Sellers.Products.OldPassword' | translate }}</label>
        <div class="input-group">
          <input class="form-control" type="password"
                  placeholder="{{ 'Sellers.Products.EnterPassword' | translate }}"
                  formControlName="old_password" [type]="oldPasswordHide ? 'password' : 'text'" data-toggle="password">
          <div class="input-group-append">
            <span (click)="oldPasswordHide = !oldPasswordHide" class="input-group-text py-3">
              <i class="fa fa-eye"></i>
            </span>
          </div>
        </div>
        <small class="text-danger" *ngIf="formValidator.formErrors.old_password">
          {{ formValidator.formErrors.old_password }}
        </small>
      </div>
      <div class="col-md-4 mb-3">
        <label>{{ 'Sellers.Products.NewPassword' | translate }}</label>
        <div class="input-group">
          <input class="form-control"
                 type="password" placeholder="{{ 'Sellers.Products.NewPassword' | translate }}"
                 data-toggle="password"
                 formControlName="new_password" [type]="newPasswordHide ? 'password' : 'text'">
          <div class="input-group-append">
            <span (click)="newPasswordHide = !newPasswordHide" class="input-group-text py-3">
              <i class="fa fa-eye"></i>
            </span>
          </div>
        </div>
        <small class="text-danger" *ngIf="formValidator.formErrors.new_password">
          {{ formValidator.formErrors.new_password }}
        </small>
      </div>
      <div class="col-md-4 mb-3">
        <label>{{ 'Sellers.Products.ConfirmPassword' | translate }}</label>
        <div class="input-group">
          <input class="form-control" type="password"
                  placeholder="{{ 'Sellers.Products.ConfirmPassword' | translate }}" formControlName="confirm_new_password"
                  [type]="confirmNewPasswordHide ? 'password' : 'text'" data-toggle="password">
          <div class="input-group-append">
            <span (click)="confirmNewPasswordHide = !confirmNewPasswordHide" class="input-group-text py-3">
              <i class="fa fa-eye"></i>
            </span>
          </div>
        </div>
        <small class="text-danger" *ngIf="formValidator.formErrors.confirm_new_password">
          {{ formValidator.formErrors.confirm_new_password }}
        </small>
      </div>
      <div class="col-auto">
        <button class="btn btn-primary" type="button" [disabled]='changePasswordForm.invalid' (click)="showOtpStep()">
          {{ 'Sellers.Products.Change' | translate }}
        </button>
      </div>
    </div>
  </form>
</div>
